import { useState } from 'react'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken } from '@/entities/user'
import { claimDailyKeyFx, openCaseFx } from '@/entities/cases'
import { $casesList } from '@/entities/cases'
import { goToReward, onError } from '@/app/routing/events'
import { getUserProfileFx } from '@/entities/user'
import WebApp from '@twa-dev/sdk'
import { setOpenedLbKind, setCaseId } from '@/entities/cases'
import { lang } from '../constants/lang'

export const useOpenDailyCase = () => {
  const [isOpening, setIsOpening] = useState<boolean>(false)
  const userToken = useUnit($userToken)
  const caseList = useUnit($casesList)
  const userLang = useUnit($userLanguage)
  const openDailyCase = async () => {
    setIsOpening(true)
    if (!userToken) return

    try {
      const data = await claimDailyKeyFx(userToken)
      if (data?.free_keys && caseList) {
        const availableToOpen = caseList
          .filter((_case) => _case.supports_free_keys)
          .find((_case) => _case.name == 'GAMED Case')
        if (!availableToOpen) {
          return WebApp.showPopup({ message: 'Oops, try again!' })
        }
        if (availableToOpen?.id) {
          setCaseId(availableToOpen.id)
        }
        if (availableToOpen) {
          await openCaseFx({
            token: userToken,
            id: availableToOpen.id,
          })
          await getUserProfileFx(userToken)
          setOpenedLbKind(true)
          localStorage.setItem('isOpenedFree', true.toString())
          goToReward()
        } else {
          WebApp.showAlert(lang[userLang].webappPopup.noLootboxes)
        }
      }
    } catch {
      onError()
    } finally {
      setIsOpening(false)
    }
  }

  return { isOpening, openDailyCase }
}
